import './sky-link-image-slider.scss';

document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.link-image-slider');

    sliders.forEach(slider => {
        const swiperContainer = slider.querySelector('.swiper-container');
        const speed = parseInt(slider.dataset.speed) || 5000;
        const pauseOnHover = slider.dataset.pauseOnHover === '1';
        const showControls = slider.dataset.showControls === '1';
        const autoScroll = slider.dataset.autoScroll === '1';

        const swiperOptions = {
            slidesPerView: 4,
            spaceBetween: 30,
            loop: true,
            autoplay: autoScroll ? {
                delay: speed,
                disableOnInteraction: false
            } : false,
            navigation: showControls ? {
                nextEl: `#${slider.id} .swiper-button-next`,
                prevEl: `#${slider.id} .swiper-button-prev`
            } : {},
            breakpoints: {
                1200: { slidesPerView: 4, spaceBetween: 10 },
                1024: { slidesPerView: 3, spaceBetween: 10 },
                768: { slidesPerView: 2, spaceBetween: 10 },
                576: { slidesPerView: 1, spaceBetween: 10 },
                0: { slidesPerView: 1, spaceBetween: 10 }
            }
        };

        const swiper = new Swiper(swiperContainer, swiperOptions);

        if (pauseOnHover && autoScroll) {
            swiperContainer.addEventListener('mouseenter', () => swiper.autoplay.stop());
            swiperContainer.addEventListener('mouseleave', () => swiper.autoplay.start());
        }
    });
});